interface JobiqoCity {
  label: string;
  lat: string;
  lon: string;
}

interface JobiqoJobBreakerConfig {
  containerId: string;
  redirectBaseUrl: string | null;
  cities: JobiqoCity[];
}

document.querySelectorAll<HTMLScriptElement>('[data-jobiqo-job-breaker-config]').forEach((configEl) => {
  const config: JobiqoJobBreakerConfig = JSON.parse(configEl.textContent || '{}');
  const container = document.getElementById(config.containerId);
  const form = container?.querySelector('form');
  if (!form) return;

  const geoInput = form.querySelector<HTMLInputElement>('[name="geo_location"]');
  const errorEl = document.getElementById(`${config.containerId}-error`);
  const trackedInvalidLocations = new Set<string>();

  // we track invalid locations entered by a user and send them to GTM
  // we track them on blur and submit (see below) and do deduplicate to avoid sending repeating values
  const trackInvalidLocations = (rawValue: string) => {
    const label = rawValue.toLowerCase();
    if (trackedInvalidLocations.has(label)) return;
    trackedInvalidLocations.add(label);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'trackingevent',
      eventCategory: 'Jobsuchstoerer',
      eventAction: 'Ort ungueltig',
      eventLabel: label,
    });
  };

  if (geoInput) {
    geoInput.addEventListener('blur', () => {
      const geoInputValue = geoInput.value.trim();
      if (geoInputValue) {
        const match = config.cities.find((c) => c.label === geoInputValue);
        if (!match) {
          if (errorEl) errorEl.hidden = false;
          trackInvalidLocations(geoInputValue);
        } else if (errorEl) {
          errorEl.hidden = true;
        }
      }
    });
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const whatInput = form.querySelector<HTMLInputElement>('[name="what"]');
    const what = whatInput ? whatInput.value : '';
    const redirectUrlString = `${config.redirectBaseUrl ?? window.location.origin}/jobs`;
    const redirectUrl = new URL(redirectUrlString);

    if (what) redirectUrl.searchParams.set('search', what);

    const geoInputValue = (geoInput ? geoInput.value : '').trim();
    if (geoInputValue) {
      const cityMatch = config.cities.find((c) => c.label === geoInputValue);
      if (!cityMatch) {
        trackInvalidLocations(geoInputValue);
        if (errorEl) errorEl.hidden = false;
        if (geoInput) { geoInput.value = ''; geoInput.focus(); }
        return;
      }
      redirectUrl.searchParams.set('geo_location', geoInputValue);
      redirectUrl.searchParams.set('lat', cityMatch.lat);
      redirectUrl.searchParams.set('lon', cityMatch.lon);
      redirectUrl.searchParams.set('radius', '25');
      redirectUrl.searchParams.set('locationType', 'locality');
    }

    // pass a tracking parameter
    redirectUrl.searchParams.set('srch_src', 'stoerer');
    window.open(redirectUrl.toString(), '_blank', 'noopener');
  });
});
